import { api, getAuthHeader } from "../axiosConfig";
import { notifyService } from "./notifyService";

export async function newUser(data) {
  return await api
    .put("/admin/newUser", data, { headers: getAuthHeader() })
    .then((res) => notifyService(res.data))
    .catch((err) => console.log(err));
}
